const SocketEnum = {
  OrderBook: "orderBook",
  OpenOrders: "openOrders",
  RecentTrades: "recentTrades",
  Credits: "credits",
  Tickers: "tickers",
}

export default SocketEnum;